module.exports = __webpack_public_path__ + "img/ILAClogo.8f3f4a60.png";